if (!customElements.get('toolbar-top')) {
  customElements.define(
    'toolbar-top',
    class ToolbarTop extends HTMLElement {
      connectedCallback () {
        const header = document.querySelector('header')
        const breadcrumb = this.querySelector('nav[aria-label="breadcrumb"] ol.breadcrumb')
        const toolbar = this.querySelector('.toolbar-top')

        if (!header || !toolbar) return
        const updateTop = () => {
          const headerHeight = header.offsetHeight
          const breadcrumbHeight = breadcrumb ? breadcrumb.offsetHeight : 0
          const topValue = headerHeight - breadcrumbHeight
          toolbar.style.top = `${topValue}px`
        }

        updateTop()
        window.addEventListener('resize', updateTop)

        const observer = new ResizeObserver(updateTop)
        observer.observe(header)
      }
    }
  )
}
